import { render, staticRenderFns } from "./WHxuansiji.vue?vue&type=template&id=7a8584ab&scoped=true&"
import script from "./WHxuansiji.vue?vue&type=script&lang=js&"
export * from "./WHxuansiji.vue?vue&type=script&lang=js&"
import style0 from "./WHxuansiji.vue?vue&type=style&index=0&id=7a8584ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8584ab",
  null
  
)

export default component.exports